import {useAppSelector} from "../../../redux/hooks";
import {mySongsFiltersStore} from "../../../pages/songs-router/modules/my-songs-filters-store/mySongsFiltersStore";


export interface IFilterDifficultySubcategoriesLogic {
  difficultyIds: number[];
}

export const useFilterDifficultySubcategoriesLogic = (difficultyCategoryId: number): IFilterDifficultySubcategoriesLogic => {
  const difficultyIds = useAppSelector(() => mySongsFiltersStore.getDifficultyIdsFromDifficultyCategoryId(difficultyCategoryId));
  return {
    difficultyIds
  };
}
